<template>
	<div class="group-field">
		<div class="wrap">
			<component :is="fieldComp" v-for="field in fields" :key="field.title" v-bind="[field, {sectionId}]"/>
		</div>

	</div>
</template>

<script>
export default {
	props: {
		fieldComp: {type: Object, required: true},
		fields: {type: Array, required: true},
		sectionId: {type: String, required: true}
	}
};
</script>

<style lang="scss" scope>
.group-field {
	.wrap {
		border: 1px solid #F5F5F5;
		border-left: 0;
		border-right: 0;
		padding: 2em 0 0;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
}
</style>
